<template>
    <v-card flat class="conteneurKeywords" id="conteneurKeywords" style="width: 100%;">
        <v-card-title class="primary white--text"  style="height: 52px;  padding: 0px;">
          <v-btn icon @click="$emit('justCloseDialog')"><v-icon class="white--text">close</v-icon></v-btn>
          <div class="title tf_title_dialog" v-html="titleDialog"></div>
          <v-spacer></v-spacer>
          <v-btn v-if="$vuetify.breakpoint.smAndDown" flat @click="submitDialog()" class="white--text">{{ $t('submit') }}</v-btn>
        </v-card-title>
        <v-card-text>
          <div v-if="loading" class="text-xs-center ">
            <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
          </div>
          <div v-else>
            <v-flex xs12 v-if="locked">
              <v-btn flat icon color="red"
                @click="toggleLocked"
              >
                <v-icon>lock</v-icon>
              </v-btn> {{ $t('AIPageLock') }}
            </v-flex>
            <v-flex xs12 v-else>
              <v-btn flat icon color="grey lighten-1"
                @click="toggleLocked"
              >
                <v-icon>lock</v-icon>
              </v-btn> {{ $t('AIPageNoLock') }}
            </v-flex>
            <v-alert
              v-if="updatedKeywords"
              :value="true"
              type="warning"
            >
              {{ $t('AIRepSeg') }}
            </v-alert>
            <v-alert
              v-else
              :value="true"
              type="success"
            >
              {{ $t('AIRepResSeg') }}
            </v-alert>

            <v-textarea
              box
              name="contentDialog"
              :label="this.$t('keywords')"
              auto-grow
              :value='contentDialog'
              v-model="contentDialog"
            ></v-textarea>
<!--
            <input
            v-for="(key, index) in JSON.parse(keys)"
              :key="index"
              type="text"
              :v-model=key[1]
              :value=key[1]
              :label=key[0]
              :id=key[0]
              @input="changeKey"
    />
-->

            <v-text-field
              v-for="(key, index) in keys"
                :key="index"
                :label=key[0]
                :value=key[1]
                @input="changeKey($event, key[0])"
            ></v-text-field>

            <v-btn flat icon color="blue" @click="toggleViewJSON">
              <v-icon>info</v-icon>
            </v-btn> {{ $t('AIDetailJSON') }}
            <v-textarea
            v-if="viewJSON"
              box
              name="keys"
              :label="this.$t('AIResumCritere')"
              auto-grow
              :value='keys'
            >
          </v-textarea>
          </div>  
        </v-card-text>
        <v-card-actions v-if="!$vuetify.breakpoint.smAndDown && !closeDialogUniquement && !modifBaseCo">
          <v-spacer></v-spacer>
          <v-btn flat @click="closeDialog()">{{ $t('no') }}</v-btn>
          <v-btn 
            :loading="loadingModif"
            :disabled="loadingModif"
            color="primary"
            @click="submitDialog()"
          >{{ $t('save') }}</v-btn>
        </v-card-actions>
        <v-card-actions v-else-if="!$vuetify.breakpoint.smAndDown && !closeDialogUniquement && modifBaseCo">
          <v-spacer></v-spacer>
          <v-btn flat @click="$emit('justCloseDialog')">{{ $t('close') }}</v-btn>
          <v-btn color="primary" @click="$emit('closeDialog')">{{ $t('ok') }}</v-btn>
        </v-card-actions>
        <v-card-actions v-else>
          <v-spacer></v-spacer>
          <v-btn flat @click="closeDialog()">{{ $t('close') }}</v-btn>
        </v-card-actions>
    </v-card>
</template>



<script>
export default {
  props: {
    dataDialog: {
      type: String,
      default: ''
    },
    titleDialog: {
      type: String,
      default: 'Confirmation'
    },
    afficheDialog: {
      type: Boolean,
      default: false
    },
    closeDialogUniquement: {
      type: Boolean,
      default: false
    },
    modifBaseCo: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      contentDialog: '',
      locked: false,
      keys: '',
      loadingModif: false,
      loading: false,
      updatedKeywords: false,
      viewJSON: false
    }
  },
  computed: {
    serveurAI () {
      if (window.location.origin.indexOf('localhost') > -1) {
        return 'https://lb-sw-generator-dev-v2.watcheebox.net/'
      } else if (window.location.origin.indexOf('backoffice-preprod') > -1) {
        return 'https://lb-sw-generator-preprod-v2.watcheebox.net/'
      } else if (window.location.origin.indexOf('backoffice') > -1) {
        return 'https://lb-sw-generator.watcheebox.net/'
      } else {
        return 'https://lb-sw-generator.watcheebox.net/'
      }
    }
  },
  mounted () {},
  updated () {},
  methods: {
    // affiche/cache le json des critères
    toggleViewJSON () {
      if (this.viewJSON) {
        this.viewJSON = false
      } else {
        this.viewJSON = true
      }
    },
    toggleLocked () {
      if (this.locked) {
        this.locked = false
      } else {
        this.locked = true
      }
    },
    closeDialog () {
      if (!this.closeDialogUniquement) {
        this.$emit('closeDialog')
      } else {
        this.$emit('justCloseDialog')
      }
    },
    // mise à jour du json des critères en temps réel
    changeKey (value, id) {
      // console.log('changeKey value ', value)
      // console.log('changeKey id ', id)
      let newKeys = this.keys
      for (let key of newKeys) {
        if (key[0] === id) {
          key[1] = value
        }
      }
      this.keys = newKeys
    },
    async submitDialog () {
      this.loadingModif = true
      // this.$emit('submitDialog', this.contentDialog)
      console.log('this.keywordUrl', this.contentDialog)
      let dataToPost = {}
      dataToPost.product = this.dataDialog
      dataToPost.keyword = this.contentDialog
      dataToPost.locked = this.locked
      dataToPost.keys = this.keys
      const response = await this.axios.post(this.serveurAI + 'setKeywordProduct',
      dataToPost,
        {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
      )
      // console.log(response.data)
      if (response.data.retour) {
        console.log('retour info : ', response.data.info)
        this.loadingModif = false
        this.$emit('majData', dataToPost)
        this.$emit('justCloseDialog')
      } else {
        console.log('info : ', response.data.info)
        this.loadingModif = false
      }
    },
    // ouvre le dialogue de modification les mots clés de la page
    async openDialogUpdateKeyword (data) {
      // console.log('this.faqDialog', this.faqDialog)
      // this.showDialogModifKeyword = true
      // console.log('open keyword', data)
      let dataToPost = {}
      dataToPost.product = data
      const response = await this.axios.post(this.serveurAI + 'getKeywordProduct',
      dataToPost,
        {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
      )
      // console.log('response : ', JSON.parse(response.data.data))
      var tokenizeData = JSON.parse(response.data.data)
      if (response.data.retour) {
        if (tokenizeData.keys) {
          this.keys = tokenizeData.keys
        } else {
          this.keys = tokenizeData.key
        }
        this.contentDialog = tokenizeData.keywords
        this.updatedKeywords = tokenizeData.updated
        this.locked = tokenizeData.locked
        this.loading = false
        // this.showDialogModifKeyword = true
      } else {
        console.log('info : ', response.data.info)
        this.contentDialog = ['pas de produit dispo']
        this.loading = false
      }
    }
  },
  watch: {
    // detect quand la dialogBow est effiché
    afficheDialog: function (val, oldVal) {
      console.log('afficheDialog val :', val)
      if (val) {
        this.loading = true
        this.openDialogUpdateKeyword(this.dataDialog)
      }
    }
  }
}
</script>

<style scoped>
  .tf_title_dialog {
    text-overflow: ellipsis;
    width: calc(100% - 180px);
    overflow: hidden;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/components/watcheezy/WzDialogOpenAIKeywordProduct.vue